<template>
  <div>
    <div style="width: 100%; text-align: center;"><h1>{{ruleData.rule_name}}规则设定</h1></div>
    <div style="display: flex; flex-direction: column;" v-if="ruleId === 'leader_pool' || ruleId === 'team_pool'">
      <div style="display: flex; flex-wrap: nowrap;height: 50px" v-for="(item,index) in ruleData.rule_item" :key="index">
        <el-switch v-model="item.is_open" active-color="#13ce66" inactive-color="#ff4949" active-text="规则开启中" inactive-text="规则关闭中"></el-switch>
        <div style="width: 350px;height: 32px;line-height: 32px;margin-left: 50px">{{ item.keywords }}</div>
        <div style="display: flex; flex-wrap: nowrap;height: 32px;line-height: 32px">
          <text style="margin-right: 20px">得分</text>
          <el-input-number v-model="item.score" :min="0"></el-input-number>
        </div>
      </div>
      <div style="display: flex;flex-wrap: nowrap">
        <div style="display: flex; flex-wrap: nowrap;height: 32px;line-height: 32px">
          <text style="margin-right: 20px">新成立企业推送分数</text>
          <el-input-number v-model="ruleData.new_score" :min="0"></el-input-number>
        </div>
        <div style="display: flex; flex-wrap: nowrap;height: 32px;line-height: 32px;margin-left: 50px">
          <text style="margin-right: 20px">老企业推送分数</text>
          <el-input-number v-model="ruleData.old_score" :min="0"></el-input-number>
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: column;" v-else>
      <div style="margin-bottom: 20px">
        <el-switch v-model="ruleData.is_open" active-color="#13ce66" inactive-color="#ff4949" active-text="规则开启中" inactive-text="规则关闭中"></el-switch>
        <el-button style="margin-left: 20px" type="primary" @click="addFormItem">新增规则</el-button>
      </div>
      <div style="margin-bottom: 20px" v-if="ruleData.rule_type === 'keywords'">
        <div v-for="(item,index) in ruleData.rule_item" :key="index">
          <el-form :inline="true" :model="item">
            <el-form-item :label="ruleData.rule_name">
              <el-input type="textarea" :rows="3" v-model="item.keywords" placeholder="多个关键词请用“，”分割" style="width: 350px"></el-input>
            </el-form-item>
            <el-form-item label="得分">
              <el-input-number v-model="item.score" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteItem(index)"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="margin-bottom: 20px" v-else>
        <div v-for="(item,index) in ruleData.rule_item" :key="index">
          <el-form :inline="true" :model="item">
            <el-form-item :label="ruleData.rule_name">
              <el-select v-model="item.keywords" placeholder="请选择" multiple style="width: 350px" clearable>
                <el-option v-for="dict in dictList" :key="dict.value" :value="dict.value" :label="dict.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="得分">
              <el-input-number v-model="item.score" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteItem(index)"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="saveItemConfig">保存配置</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "KeywordsFormRule",
  props: {
    ruleId: {
      type: String
    }
  },
  data() {
    return {
      score:0,
      ruleData:{},
      dictList:[]
    }
  },
  watch: {
    ruleId: {
      immediate: true,
      handler(newVal) {
        this.getRuleConfig(newVal)
      }
    }
  },
  created() {},
  methods:{
    getRuleConfig(ruleKey){
      this.$http('crmCompanyPushService.getCompanyPushConfig',{
        rule_key: ruleKey
      }).then(res => {
        this.ruleData = res
        if (this.ruleData.rule_type === 'dict'){
          this.dictList = res.dict_list
        }
      })
    },
    addFormItem(){
      this.ruleData.rule_item.push({})
    },
    async saveItemConfig() {
      let res = await this.$http('crmCompanyPushService.updateCompanyPushConfig', this.ruleData)
      this.$message.success("规则保存成功")
    },
    deleteItem(index){
      this.ruleData.rule_item.splice(index,1)
    }
  }
}
</script>

<style lang="less">

</style>

<style scoped>

</style>